<template>
    <div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasExample"
  aria-labelledby="offcanvasExampleLabel">
    <div class="offcanvas-header">
      <h5 class="offcanvas-title text-light fw-bold" id="offcanvasExampleLabel">答錯的題目 🤔</h5>
      <button type="button" class="btn-close text-reset"
      data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body">
        <div v-for="(q, index) in wrongs" :key="q.qno"
        class="mb-2 text-start wrong-question">
          <a :href="'/#/q/' + q" class="text-decoration-none">
            {{index+1}}. {{ q }}
          </a>
        </div>
    </div>
  </div>
</template>

<script>
export default ({
  props: ['wrongs'],
  data() {
    return {
    };
  },
});
</script>

<style scoped lang="scss">
// legal pad style
// https://codepen.io/ix4/pen/JjogPdm

.offcanvas-body{
  padding: 0;
}

.wrong-question{
  padding-left: 10px;
  margin-bottom: 0px !important;
  font-size: 1.6rem;
  line-height: 2rem;
  border-bottom:#cce0ff 2px solid;
}

.offcanvas-header{
  background: #A44040;
  border-bottom: 4px solid #8e3838;
}

.offcanvas{
  background: #FFFFCC;
  border-right: 1px;
}
</style>
